import {ServerConfig} from '@/config/routers';
import sdk from '@/sdk';

/* eslint-disable */
export function concatImgSrc(        
    userGuid?: string,
    spaceGuid?: string,
    groupGuid?: string,
    repositoryGuid?: string,
    uploadTime?: number,
    repositoryTemplateId?: string,
    gid?: number | string,
) {
    let avatarSrc = '';
    const isTocPage = window.isTocPage;
    // 目前toc只改造了/users/avatar，看看后面几个获取头像的接口跟后端确认，mvp版本暂时用不上
    if (userGuid) {
        avatarSrc = `${isTocPage? ServerConfig.toc : ServerConfig.ku}/users/avatar?userGuid=${userGuid}`;
    } else if (spaceGuid && groupGuid && repositoryGuid) {
        // eslint-disable-next-line max-len
        avatarSrc = `${ServerConfig.as}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/resources/avatar?${uploadTime || ''}`;
    } else if (repositoryTemplateId) {
        avatarSrc = `${ServerConfig.as}/templates/repository/${repositoryTemplateId}/avatar`;
    } else if (gid) {
        avatarSrc = `${ServerConfig.as}/rl/knowledge/${gid}/avatar`
    } else if (spaceGuid && groupGuid) {
        avatarSrc = sdk.as.getDepLogoUploadUrl(spaceGuid, groupGuid);
    }

    return avatarSrc;
}
